@if (!isMobile) {
    <div class="bin-collection-history">
        <div class="header-container-wrapper">
            <div class="title-container">
                @if (usageType == 1) {
                    {{ 'TITLES.COLLECTION_HISTORY' | translate }}
                }
                @if (usageType == 2) {
                    {{ 'TITLES.FILLINGS_HISTORY' | translate }}
                }        
            </div>
            <div class='export-btns-wrapper' (click)="exportToCsv()">
                <img class='table-export-img' src="assets/images/binInfoPage/Excel.svg" alt="" />
                <div class='table-export-title' rtlDiv>{{ 'OTHER.EXCEL' | translate }}</div>
            </div>
        </div>
        <div class='collection-data-wrapper'>
            @if (LastCollectionTime != '') {
                <div class='info-item-container'>
                    <img class="info-icon" src="../assets/images/binInfoPage/alert.svg" rtlDiv />
                    <span class="info-text" rtlDiv>
                        @if (usageType == 1) {
                            {{ 'LIVE_INFO.LAST_COLLECTION' | translate }}
                        }
                        @if (usageType == 2) {
                            {{ 'LIVE_INFO.LAST_FILLING' | translate }}
                        }
                        {{LastCollectionTime}}
                    </span>
                </div>
            }
            <div class='info-item-container'>
                <img class="info-icon" src="../assets/images/binInfoPage/alert.svg" rtlDiv />
                <span class="info-text" rtlDiv>
                    @if (usageType == 1) {
                        {{ 'LIVE_INFO.TOTAL_COLLECTIONS' | translate }}
                        {{countCollectionLastWeek}}
                    }
                    @if (usageType == 2) {
                        {{ 'LIVE_INFO.TOTAL_FILLINGS' | translate }}
                        {{countCollectionLastWeek}}
                    }
                </span>
            </div>
        </div>
        <div class='table-wrapper'>
            <table class="table" mat-table #table [dataSource]="dataSource" matSort matSortStart="desc" matSortActive="collection_date"
                matSortDisableClear (matSortChange)="sortData($event)" matSortDirection="desc">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" rtlDiv>
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="collection_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="collection_date" class="table-header-cell">
                        @if (usageType == 1) {
                        <span>{{'LIVE_INFO.LIST_COLLECTION_DATE' | translate }}</span>
                        }
                        @if (usageType == 2) {
                        <span>{{'LIVE_INFO.LIST_FILLING_DATE' | translate }}</span>
                        }
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-cell" > {{element ? element.collection_date : ''}} </td>
                </ng-container>
                <!-- id Column -->
                <ng-container matColumnDef="collection_time">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="collection_time" class="table-header-cell">
                        @if (usageType == 1) {
                        <span>{{'LIVE_INFO.LIST_COLLECTION_TIME' | translate }} </span>
                        }
                        @if (usageType == 2) {
                        <span>{{'LIVE_INFO.LIST_FILLING_TIME' | translate }} </span>
                        }
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-cell"> {{element ? element.collection_time : ''}} </td>
                </ng-container>>
                <!-- status Column -->
                <ng-container matColumnDef="capacity_at_pick_up">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="capacity_at_pick_up" class="table-header-cell">
                        @if (usageType == 1) {
                        <span>{{'LIVE_INFO.LIST_PICKUP_CAPACITY' | translate }}</span>
                        }
                        @if (usageType == 2) {
                        <span>{{'FILLINGS.REFILL_AMOUNT' | translate }}</span>
                        }
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-cell">
                        <div class="table-status-progress-bar-wrapper-container">
                            @if (usageType == 1) {
                                <div class="table-status-progress-bar-wrapper" [ngStyle]="getProgressBarStyleWrapper(element)">
                                    <div class="table-status-progress-line" [ngStyle]="getProgressBarStyleInternal(element)"></div>
                                </div>
                            }
                            <div class='table-status-progress-bar-title' rtlDiv>
                                <span>{{element ? element.capacity_at_pick_up: ''}}</span>
                                @if (usageType == 1) {
                                    <span>%</span>
                                }
                                @if (usageType == 2 && currentLang == 'iw') {
                                    <span> ל</span>
                                }
                                @if (usageType == 2 && currentLang != 'iw') {
                                    <span> L</span>
                                }
                            </div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
            </table>
            <div [hidden]="dataTableLength === 0">
                <app-pagination [chosenBins]="binCollectionData" (pageChange)='onPageChange($event)' [filesPerPage]="6"></app-pagination>
            </div>
        </div>
    </div>
}

@if (isMobile) {

}